export const authRoles = {
    sa: ['SA'], // Only Super Admin has access
    admin: ['SA', 'ADMIN'], // Only SA & Admin has access
    editor: ['SA', 'ADMIN', 'EDITOR'], // Only SA & Admin & Editor has access
    guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST'], // Everyone has access
    puestotrabajo:['SA', 'ADMIN', 'EDITOR', 'GUEST','PUESTO'] //Acceso atodo lo que tiene guest y la pantalla de puesto de trabajo
}
